module.exports = __webpack_public_path__ + "static/media/artwork-preview.7d7d4a3a.png";